// extracted by mini-css-extract-plugin
export default {"button":"ebGds","hiddenLabel":"iCWyW"};